import { Radar } from "lucide-react";

// Options used to tag inquiries by which solution/interest the lead has.
export const INTEREST_OPTIONS = [
  { value: "Licara", slug: "licara" },
  { value: "Custom solution", slug: "custom" },
  { value: "General inquiry", slug: "general" },
];

export const slugToInterest = (slug) => {
  const match = INTEREST_OPTIONS.find((o) => o.slug === slug);
  return match ? match.value : "";
};

// Sentira's solutions. Licara is our flagship, purpose-built product.
export const SOLUTIONS = [
  {
    id: "licara",
    name: "Licara",
    path: "/solutions/licara",
    icon: Radar,
    tagline: "Enforcement, permits & licensing platform",
    description:
      "Our flagship product. Unify permits, inspections, field citations, and case management in one secure hub.",
    badge: "Flagship product",
  },
];
